import React, {useEffect, useState} from "react";
import ReactTable from "../../../components/ReactTableWrapper";

import connection from "../../../connection";
import Connection from "../../../connection";
import general from "../../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SweetAlert from "../../../components/SweetAlertWrapper";

import cursosStyle from "assets/jss/material-dashboard-pro-react/views/cursosStyle";
import Add from "@material-ui/icons/Add";
import Refresh from "@material-ui/icons/Refresh";
import UserSearch from "../../../components/UserSearch";
import UserDetailsBox from "../../../components/UserDetailsBox";
import RegistrationState from "../../../components/RegistrationState";
import Datetime from "../../../components/DatetimeWrapper";
import Create from "@material-ui/icons/Create";
import Delete from "@material-ui/icons/Delete";
import Person from "@material-ui/icons/Person";
import List from "@material-ui/icons/List";
import Description from "@material-ui/icons/Description";
import Attachment from "@material-ui/icons/Attachment";
import NavPills from "../../../components/NavPills/NavPills";
import CustomInput from "../../../components/CustomInput/CustomInput";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "../../../../node_modules/@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Accordion from "../../../components/Accordion/Accordion";
import StateCircle from "../../../components/StateCircle";
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import MoreVert from "../../../../node_modules/@material-ui/icons/MoreVert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCoins, faExclamationTriangle, faFileExcel, faSearchPlus} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@material-ui/core/Tooltip";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import EstadoParticipacaoCurso from "../../../components/EstadoParticipacaoCurso";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import {Close, CloudDownload, Send} from "@material-ui/icons";
import EditarRelatorio from "./editar_relatorio";
import Parser from "html-react-parser";
import moment from "moment";
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import {fases} from "./fases";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import ReactDOM from "react-dom";
import Masonry from "react-masonry-css";
import EquipaFormacao from "../../../components/EquipaFormacao";
import AnexoAcontecimento from "../../../components/AnexoAcontecimento/AnexoAcontecimento";
import EstadoUtilizador from "../../../components/EstadoUtilizador";
import Popover from "@material-ui/core/Popover";
import Paper from "@material-ui/core/Paper";
import MenuList from "@material-ui/core/MenuList";

const portal = document.createElement('div');
portal.classList.add('my-super-cool-portal');

if (!document.body) {
  throw new Error('body not ready for portal creation!');
}

document.body.appendChild(portal);

function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

const Map = withScriptjs(
  withGoogleMap(props => {
    return <GoogleMap
      defaultZoom={16}
      defaultCenter={{lat: props.lat, lng: props.lon}}
      defaultOptions={{
        disableDefaultUI: true
      }}
      center={{lat: props.lat, lng: props.lon}}
    >
      <Marker position={{lat: props.lat, lng: props.lon}}/>
    </GoogleMap>
  })
);

const CardFormacao = (props) => {
  return <Draggable key={props.id} draggableId={"formacao_" + props.id} index={props.index}>
    {(
      {draggableProps, dragHandleProps: eventHandlers, innerRef},
      {isDragging}
    ) => {
      let children = <div ref={innerRef} {...draggableProps} {...eventHandlers} style={{...draggableProps.style, padding: "10px 0"}}><Card style={{margin: 0}}>
        <CardHeader color="info">
          <div style={{display: "flex", justifyContent: "space-between", padding: "5px 0"}}>
            <p style={{margin: 0}}>
              <StateCircle state={props.estado}/> #{general.pad(props.id, 5)} - {props.codigo_modulo} | {props.modulo}
            </p>
            <Button
              justIcon
              round
              simple
              onClick={() => {
                window.App.hist.push("/formacao/" + props.id);
              }}
              style={{margin: -10}}
              color="info"
              className="edit"
            >
              <FontAwesomeIcon icon={faSearchPlus}/>
            </Button>
          </div>
          <table width={"100%"}>
            <tr>
              <td>
                <h6>Inscritos</h6>
                <span>{props.inscritos + (props.vagas ? " (" + props.vagas + " vagas)" : '')}</span>
              </td>
              <td>
                <h6>Participantes</h6>
                <span>{props.participantes}</span>
              </td>
              <td>
                <h6>Presentes</h6>
                <span>{props.presentes}</span>
              </td>
              <td>
                <h6>Formador</h6>
                <span>{general.Renderers.userRenderer(props.formador)}</span>
              </td>
            </tr>
          </table>
          <div>
            De {general.Renderers.dateRenderer(props.data_inicio, {hide_timezone: true})} até {general.Renderers.dateRenderer(props.data_fim, {hide_timezone: true})}
          </div>
        </CardHeader>
      </Card></div>;

      const usePortal = isDragging;

      if (!usePortal) {
        return children;
      }

      // if dragging - put the item in a portal
      return ReactDOM.createPortal(children, portal);
    }}
  </Draggable>
}

class PaginaCurso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curso: props.detalhes,
      participantes: {},
      modal: null,
      feedback_forcado: false,
    };

    this.hideModal = this.hideModal.bind(this);
    this.inscreverFormando = this.inscreverFormando.bind(this);

    this.reloadParticipantesCurso = async () => {
      let participantes = await connection.get("curso/participantes/listagem", {id_curso: this.state.curso.id});

      this.setState({
        participantes: participantes,
        modal: null
      })
    };

    this.reloadModulosCurso = async () => {
      this.setState({
        modulos: await connection.get("curso/modulos", {curso_id: this.state.curso.id}),
        modal: null
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {curso: props.detalhes};
  }

  componentDidMount() {
    this.reloadParticipantesCurso();
    this.reloadModulosCurso();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.detalhes.id !== prevProps.detalhes.id) {
      this.reloadParticipantesCurso();
      this.reloadModulosCurso();
    }
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  inscreverFormando(recurso = false) {
    const {classes} = this.props;

    let formando = null;
    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Inscrever Formando no Curso</span>
        </div>)}
        onConfirm={() => {
          connection.post("curso/participante/inscrever" + (recurso ? "_recurso" : ""), {curso: this.state.curso.id, formando: formando}, (data) => {
            this.reloadParticipantesCurso();
            general.success("Formando inscrito com sucesso.", "Sucesso!");
          });
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Inscrever"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Formando"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              formando = user.NIN
            }}
          />
        </form>
      </SweetAlert>)
    });
  }

  editDetalhesCurso = async () => {
    const {classes} = this.props;

    let regioes = await connection.get("regiao/listagem");
    let nucleos = await connection.get("nucleo/listagem");
    let agrupamentos = await connection.get("agrupamento/listagem");

    if (!regioes.find((reg) => reg.id === this.state.curso.id_regiao))
      regioes.unshift({id: this.state.curso.id_regiao || 0, designacao: this.state.curso.regiao || 'Nenhuma'});
    if (!nucleos.find((nuc) => nuc.id === this.state.curso.id_nucleo))
      nucleos.unshift({id: this.state.curso.id_nucleo || 0, designacao: this.state.curso.nucleo || 'Nenhum', regiao: null});
    if (!agrupamentos.find((ag) => ag.id === this.state.curso.id_agrupamento))
      agrupamentos.unshift({id: this.state.curso.id_agrupamento || 0, designacao: this.state.curso.agrupamento || 'Nenhum', nucleo: null});

    let curso = {
      agrupamento: this.state.curso.id_agrupamento || 0,
      nucleo: this.state.curso.id_nucleo || 0,
      regiao: this.state.curso.id_regiao || 0,
      diretor: this.state.curso.diretor,
      descricao: this.state.curso.descricao
    };

    let Content = () => {
      const [curso_agrupamento_state, setAgrupamentoState] = useState(curso.agrupamento);
      const [curso_nucleo_state, setNucleoState] = useState(curso.nucleo);
      const [curso_regiao_state, setRegiaoState] = useState(curso.regiao);
      const [simulacao, setSimulacao] = useState(null);

      let nucleo_ativo = nucleos.find((nucleo) => nucleo.id === curso_nucleo_state);
      let regiao_ativa = regioes.find((regiao) => regiao.id === curso_regiao_state);

      const simular = async () => {
        try {
          let resultado = await connection.post("curso/editar_detalhes?simulacao=1", {
            curso: this.state.curso.id,
            agrupamento: curso.agrupamento || null,
            nucleo: curso.nucleo || null,
            regiao: curso.regiao || null,
            diretor: curso.diretor.NIN,
            descricao: curso.descricao
          }, null, null, {disableNotif: true, returnError: true});
          setSimulacao(resultado);
        } catch (e) {
          setSimulacao(e);
        }
      }

      useEffect(() => {
        simular();
      }, [curso_regiao_state]);

      let mensagem = null;
      if (simulacao) {
        if (simulacao.success) {
          if (this.state.curso.descricao !== simulacao.descricao)
            mensagem = <>A descrição do curso será alterada para: <b>{simulacao.descricao}</b></>;
        } else {
          mensagem = simulacao?.message;
        }
      }

      return <form autoComplete="off" className={classes.addForm}>
        {mensagem && <div style={{margin: "10px 0px 30px"}}>
          <SnackbarContent
            message={mensagem}
            color={simulacao.success ? "warning" : "danger"}
          />
        </div>}
        {general.userHasType("admin") && <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            defaultValue: curso.descricao,
            onChange: (e) => {
              curso.descricao = e.target.value
            }
          }}
        />}
        <UserSearch
          labelText="Diretor"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0"
          }}
          defaultUser={curso.diretor}
          onFoundUser={(user) => {
            curso.diretor = user
          }}
        />
        {general.userHasType("admin", "chefe_nacional") && <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Região
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={curso_regiao_state}
            onChange={(event) => {
              if (curso.regiao === event.target.value)
                return;
              curso.nucleo = null;
              setNucleoState(null);
              curso.agrupamento = null;
              setAgrupamentoState(null);
              curso.regiao = event.target.value;
              setRegiaoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a região</MenuItem>
            {this.state.curso.regiao && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhuma</MenuItem>}
            {regioes.map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>}
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Núcleo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={curso_nucleo_state}
            onChange={(event) => {
              if (curso.nucleo === event.target.value)
                return;
              curso.agrupamento = null;
              setAgrupamentoState(null);
              curso.nucleo = event.target.value;
              setNucleoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o núcleo</MenuItem>
            {this.state.curso.nucleo && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhum</MenuItem>}
            {nucleos.filter(nucleo => regiao_ativa && nucleo.regiao === regiao_ativa.codigo || nucleo.id === 0).map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        {/*<FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Agrupamento
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={curso_agrupamento_state}
            onChange={(event) => {
              if (curso.agrupamento === event.target.value)
                return;
              curso.agrupamento = event.target.value;
              setAgrupamentoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o agrupamento</MenuItem>
            {this.state.curso.agrupamento && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhum</MenuItem>}
            {agrupamentos.filter(agrupamento => nucleo_ativo && agrupamento.nucleo === nucleo_ativo.codigo || agrupamento.id === 0).map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}{item.codigo && <span> ({item.codigo})</span>}</MenuItem>;
            })}
          </Select>
        </FormControl>*/}
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Detalhes</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/editar_detalhes", {
            curso: this.state.curso.id,
            agrupamento: curso.agrupamento || null,
            nucleo: curso.nucleo || null,
            regiao: curso.regiao || null,
            diretor: curso.diretor.NIN,
            descricao: curso.descricao
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Curso editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  promptModal = (designacao, instrucoes, valor, callback) => {
    const {classes} = this.props;

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar {designacao}</span>
        </div>)}
        onConfirm={() => callback(valor)}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <p>{instrucoes}</p>
          <CustomInput
            formControlProps={{
              fullWidth: true,
              style: {padding: 0, margin: 0}
            }}
            inputProps={{
              type: "text",
              multiline: true,
              defaultValue: valor,
              placeholder: "Escrever " + designacao.toLowerCase(),
              rows: 3,
              onChange: (e) => {
                valor = e.target.value
              }
            }}
          />
        </form>
      </SweetAlert>)
    });
  };

  editPropriedadesCurso = async () => {
    const {classes} = this.props;

    let modalidades = await connection.get("formacao/modalidades");

    // Remover modalidades desativadas, a menos que a opção esteja selecionada
    modalidades = modalidades.filter(m => !m.desativado || m.codigo === this.state.curso.modalidade);

    let pode_editar_modalidade = true;

    let pode_alterar_pagamento_ou_modalidade = !(this.state.curso.referencias_geradas > 0) && !(this.state.curso.participantes > 0);

    if (this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_FINALIZADOS && !general.userHasType("admin", "secretario_regional"))
      pode_editar_modalidade = false;

    let curso = {
      data_abertura_registos: this.state.curso.data_abertura_registos,
      data_limite_registos: this.state.curso.data_limite_registos,
      data_inicio_curso: this.state.curso.data_inicio_curso,
      data_fim_curso: this.state.curso.data_fim_curso,
      vagas: this.state.curso.vagas,
      preco: this.state.curso.preco,
      preco_para_percurso: this.state.curso.preco_para_percurso,
      pagamento_antecipado: this.state.curso.pagamento_antecipado,
      modalidade: this.state.curso.modalidade || modalidades[0]?.codigo,
      limite_inscricoes: this.state.curso.limite_inscricoes,
    };

    let gratuito = curso.preco === 0;
    let gratuito_percurso = curso.preco_para_percurso === 0;
    let pagar_antecipado = (curso.preco === 0) ? false : curso.pagamento_antecipado;
    let limite_candidaturas = curso.limite_inscricoes > 0;

    let Content = () => {
      const [curso_preco_gratuito_state, setGratuito] = useState(gratuito);
      const [pagamento_antecipado, setPagamentoAntecipado] = useState(!!pagar_antecipado);
      const [preco, setPreco] = useState(curso.preco);
      const [curso_preco_gratuito_percurso_state, setGratuitoPercurso] = useState(gratuito_percurso);
      const [simulacao, setSimulacao] = useState(null);
      const [modalidade_state, setModalidadeState] = useState(curso.modalidade);
      const [curso_limite_candidatura_state, setLimiteCandidaturas] = useState(limite_candidaturas);
      const [limiteInscricoes, setLimiteInscricoes] = useState(curso.limite_inscricoes);

      const simular = async () => {
        try {
          let resultado = await connection.post("curso/editar_informacoes?simulacao=1", {
            curso: this.state.curso.id,
            data_abertura_registos: curso.data_abertura_registos,
            data_limite_registos: curso.data_limite_registos,
            data_inicio_curso: curso.data_inicio_curso,
            data_fim_curso: curso.data_fim_curso,
            vagas: curso.vagas,
            preco: gratuito ? 0 : curso.preco,
            preco_para_percurso: gratuito_percurso ? 0 : curso.preco_para_percurso,
            pagamento_antecipado: pagamento_antecipado,
            modalidade: curso.modalidade || modalidades[0]?.codigo,
            limite_inscricoes: limite_candidaturas ? limiteInscricoes : null,
          }, null, null, {disableNotif: true, returnError: true});
          setSimulacao(resultado);
        } catch (e) {
          setSimulacao(e);
        }
      }

      let mensagem = [];
      if (simulacao) {
        if (simulacao.success) {
          if (this.state.curso.descricao !== simulacao.descricao)
            mensagem.push(<>A descrição do curso será alterada para: <b>{simulacao.descricao}</b></>);
          if (this.state.curso.modalidade !== simulacao.modalidade && simulacao.modalidade !== 'BLEARNING')
            mensagem.push(<>{mensagem.length > 0 ? <br/> : null}Os módulos deste curso também serão alterados para a modalidade {simulacao.modalidade === 'PRESENCIAL' ? 'presencial' : 'e-learning'}.</>);
        } else {
          mensagem = simulacao?.message;
        }
      }

      let input_modalidade = <FormControl fullWidth className={classes.selectFormControl + " " + (!pode_editar_modalidade ? classes.disabled : null)}>
        <InputLabel className={classes.selectLabel}>
          Modalidade
        </InputLabel>
        <Select
          MenuProps={{
            className: classes.selectMenu
          }}
          classes={{
            select: classes.select
          }}
          value={modalidade_state}
          onChange={(event) => {
            if (curso.modalidade === event.target.value)
              return;
            curso.modalidade = event.target.value;
            setModalidadeState(event.target.value);
            simular();
          }}
        >
          <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a modalidade</MenuItem>
          {modalidades.map((item) => {
            return <MenuItem key={item.codigo} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.codigo}>{item.designacao}</MenuItem>;
          })}
        </Select>
      </FormControl>

      return <form autoComplete="off" className={classes.addForm}>
        {mensagem.length > 0 && <div style={{margin: "10px 0px 30px"}}>
          <SnackbarContent
            message={mensagem}
            color={simulacao.success ? "warning" : "danger"}
          />
        </div>}
        {pode_editar_modalidade && pode_alterar_pagamento_ou_modalidade && input_modalidade}
        {!pode_editar_modalidade && pode_alterar_pagamento_ou_modalidade && <Tooltip title={"Já não é possível alterar a modalidade. Contacte o apoio."} placement="bottom">
          <div>{input_modalidade}</div>
        </Tooltip>}
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Abertura de registos
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              curso.data_abertura_registos = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={curso.data_abertura_registos}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Data-limite para registos
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              curso.data_limite_registos = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={curso.data_limite_registos}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Início do curso
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              curso.data_inicio_curso = value;
              simular();
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={curso.data_inicio_curso}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Fim do curso
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              curso.data_fim_curso = value;
              simular();
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={curso.data_fim_curso}
          />
        </FormControl>
        <CustomInput
          labelText="Vagas"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            defaultValue: curso.vagas,
            onChange: (e) => {
              curso.vagas = e.target.value
            }
          }}
        />
        {this.state.curso.estado.code < general.estadosAcontecimento.REGISTOS_FINALIZADOS && <>
          <FormControlLabel
            control={
              <Checkbox
                checked={curso_limite_candidatura_state}
                tabIndex={-1}
                onClick={() => {
                  limite_candidaturas = !curso_limite_candidatura_state;
                  setLimiteCandidaturas(!curso_limite_candidatura_state);
                }}
                checkedIcon={<Check className={classes.checkedIcon}/>}
                icon={<Check className={classes.uncheckedIcon}/>}
                classes={{
                  checked: classes.checked
                }}
              />
            }
            classes={{
              label: classes.label
            }}
            label={"Limite de candidaturas"}
          /><br/>
          {curso_limite_candidatura_state && <CustomInput
            labelText="Limite de inscrições"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0",
              step: 0.01,
              defaultValue: curso.limite_inscricoes,
              onChange: (e) => {
                setLimiteInscricoes(e.target.value)
                curso.limite_inscricoes = e.target.value
              }
            }}
          />}
          {pode_alterar_pagamento_ou_modalidade && <>
            <FormControlLabel
              control={
                <Checkbox
                  checked={curso_preco_gratuito_state}
                  tabIndex={-1}
                  onClick={() => {
                    gratuito = !curso_preco_gratuito_state;
                    setGratuito(!curso_preco_gratuito_state);
                    if (!curso_preco_gratuito_state) {
                      setPagamentoAntecipado(false);
                      pagar_antecipado = false;
                    }
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Gratuito"}
            /><br/>
            {!curso_preco_gratuito_state && <>
              <CustomInput
                labelText="Preço (€)"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: 0.01,
                  defaultValue: curso.preco,
                  onChange: (e) => {
                    setPreco(e.target.value)
                    curso.preco = e.target.value
                  }
                }}
              />
              {preco > 0 && <><FormControlLabel
                control={
                  <Checkbox
                    checked={pagamento_antecipado}
                    tabIndex={-1}
                    onClick={() => {
                      pagar_antecipado = !pagamento_antecipado;
                      setPagamentoAntecipado(!pagamento_antecipado);
                    }}
                    checkedIcon={<Check className={classes.checkedIcon}/>}
                    icon={<Check className={classes.uncheckedIcon}/>}
                    classes={{
                      checked: classes.checked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={"Pagamento antecipado"}
              /><br/></>}
            </>}
            {this.state.curso.percurso && <React.Fragment>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={curso_preco_gratuito_percurso_state}
                    tabIndex={-1}
                    onClick={() => {
                      gratuito_percurso = !curso_preco_gratuito_percurso_state;
                      setGratuitoPercurso(!curso_preco_gratuito_percurso_state);
                    }}
                    checkedIcon={<Check className={classes.checkedIcon}/>}
                    icon={<Check className={classes.uncheckedIcon}/>}
                    classes={{
                      checked: classes.checked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={"Gratuito para inscritos no percurso"}
              />
              {!curso_preco_gratuito_percurso_state && <CustomInput
                labelText="Preço para inscritos no percurso (€)"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: 0.01,
                  defaultValue: curso.preco_para_percurso,
                  onChange: (e) => {
                    curso.preco_para_percurso = e.target.value
                  }
                }}
              />}
            </React.Fragment>}
          </>}
        </>}
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Informações</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/editar_informacoes", {
            curso: this.state.curso.id,
            data_abertura_registos: curso.data_abertura_registos,
            data_limite_registos: curso.data_limite_registos,
            data_inicio_curso: curso.data_inicio_curso,
            data_fim_curso: curso.data_fim_curso,
            vagas: curso.vagas,
            preco: gratuito ? 0 : curso.preco,
            preco_para_percurso: gratuito_percurso ? 0 : curso.preco_para_percurso,
            pagamento_antecipado: pagar_antecipado,
            modalidade: curso.modalidade,
            limite_inscricoes: limite_candidaturas ? curso.limite_inscricoes : null
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Curso editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  moverCandidatos = async () => {
    const {classes} = this.props;

    let candidatos = this.state.participantes.candidatos;
    candidatos = candidatos.filter(candidato => candidato.estado_pagamento === 'PAGO');
    let candidatos_ids = candidatos.map(candidato => candidato.id);

    let cursos = (await connection.get("curso/listagem", {disponiveis_apenas: true})).cursos;
    cursos = cursos.filter(curso => (curso.tipo_curso === this.state.curso.tipo && curso.id !== this.state.curso.id));

    let Content = () => {
      const [curso_destino, setCursoDestino] = useState(null);
      const [mover_candidatos, setMoverCandidatos] = useState(candidatos_ids);

      return <>
        <SweetAlert
          style={{width: "650px"}}
          title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
            <span className={classes.modalCardTitle}>Mover Candidatos</span>
          </div>)}

          onConfirm={async () => {
            let result = await connection.post("curso/candidatos/mover", {
              curso_origem: this.state.curso.id,
              curso_destino: curso_destino,
              candidatos: mover_candidatos
            });
            window.App.hist.push("/curso/" + result.id);
            window.App.hideModal();
            general.success("Candidato(s) movido(s)", "Sucesso");
          }}
          onCancel={() => this.hideModal()}
          cancelBtnText="Cancelar"
          showCancel
          confirmBtnText="Mover"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm + (curso_destino && mover_candidatos.length > 0 ? "" : " " + classes.disabled)
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <ReactTable
            placeholder={["Não há candidatos para mover."]}
            data={[...candidatos]}
            minRows={1}
            columns={[
              {
                Header: "Mover",
                accessor: "id",
                width: 85,
                Cell: (row) => {
                  return <Checkbox
                    checked={mover_candidatos.includes(row.original.id)}
                    tabIndex={-1}
                    onClick={() => {
                      if (mover_candidatos.includes(row.original.id)) {
                        mover_candidatos.splice(mover_candidatos.indexOf(row.original.id), 1);
                        setMoverCandidatos([...mover_candidatos]);
                      } else {
                        mover_candidatos.push(row.original.id)
                        setMoverCandidatos([...mover_candidatos]);
                      }
                    }}
                    checkedIcon={<Check className={classes.checkedIcon}/>}
                    icon={<Check className={classes.uncheckedIcon}/>}
                    classes={{
                      checked: classes.checked
                    }}
                  />;
                }
              },
              {
                Header: "Nome",
                accessor: "nome",
                width: 300,
                Cell: (row) => {
                  return <span>
                    {row.value}
                    <span style={{fontSize: 12, display: "block", marginTop: -3, color: "#5e5e5e"}}>{row.original.nin}</span>
                  </span>
                }
              },
              {
                Header: "Estado de pagamento",
                accessor: "estado_pagamento",
                width: 220,
              }
            ]}
            className="-striped -highlight"
          />
          <h4 style={{padding: "0 10px", margin: "20px 0 -5px"}}>Selecionar um curso:</h4>
          <form autoComplete="off" style={{padding: "0 10px"}}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="tipo_curso" className={classes.selectLabel}>
                {this.state.curso.tipo}
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={curso_destino}
                onChange={(event) => {
                  setCursoDestino(event.target.value);
                }}
              >
                <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o curso</MenuItem>
                {cursos.map((curso) => {
                  return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} disabled={false} value={curso.descricao}>{curso.descricao} ({curso.regiao})</MenuItem>;
                })}
              </Select>
            </FormControl>
          </form>
        </SweetAlert>
      </>
    };

    this.setState({
      modal: <Content/>
    });
  };

  render() {
    const {classes, location} = this.props;
    const {curso} = this.state;
    const num_inscritos = this.state.participantes.candidatos?.length + this.state.participantes.participantes?.length;

    return this.state.curso ? (<div className={classes.cursosContainer}>
      {fases(curso)}
      {this.state.modal}
      {this.state.curso.data_relatorio_rejeitado && <div className={classes.warningLabel}>
        <span className="">O relatório submetido foi rejeitado, faça os devidos ajustes e submeta novamente</span>
      </div>}
      <GridContainer>
        <GridItem xs={12} sm={5}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}><StateCircle state={curso.estado}/>{curso.descricao}</h4>
                {curso.pode_gerir_detalhes && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editDetalhesCurso}>
                  <Create/> Editar
                </Button>}
              </div>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <table>
                <tr>
                  <td>Tipo de curso:</td>
                  <td>{curso.tipo + (curso.tags ? ' (' + curso.tags + ')' : '')}</td>
                </tr>
                {curso.percurso && <tr>
                  <td>Percurso:</td>
                  <td><span className="clickable" onClick={() => {
                    window.App.hist.push("/percurso/" + curso.percurso.id);
                  }}>{curso.percurso.designacao}</span></td>
                </tr>}
                {curso.relatorio_os && <tr>
                  <td>OSR/ OSN:</td>
                  <td>{curso.relatorio_os} ({moment(curso.relatorio_os_data).format("DD/MM/YYYY")})</td>
                </tr>}
                <tr>
                  <td>Diretor:</td>
                  <td>{general.Renderers.userRenderer(curso.diretor)}</td>
                </tr>
                <tr>
                  <td>Região:</td>
                  <td>{curso.regiao || '-'}</td>
                </tr>
                <tr>
                  <td>Núcleo:</td>
                  <td>{curso.nucleo || '-'}</td>
                </tr>
                {/*<tr>
                  <td>Agrupamento:</td>
                  <td>{curso.agrupamento || '-'}</td>
                </tr>*/}
              </table>
            </CardBody>
          </Card>
          <EquipaFormacao acontecimento={this.state.curso}/>
        </GridItem>
        <GridItem xs={12} sm={7}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Gestão de curso</h4>
                {curso.pode_gerir && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editPropriedadesCurso}>
                  <Create/> Editar
                </Button>}
              </div>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <table>
                <tr>
                  <td>Modalidade:</td>
                  <td>{curso.modalidade_designacao}</td>
                </tr>
                <tr>
                  <td>Vagas:</td>
                  <td>{curso.vagas ? (curso.vagas + " (" + (curso.vagas - curso.selecionados) + " restantes)") : "Por definir"}</td>
                </tr>
                {curso.limite_inscricoes && this.state.curso.estado.code < general.estadosAcontecimento.REGISTOS_FINALIZADOS && <tr>
                  <td>Limite de inscrições:</td>
                  <td>{curso.limite_inscricoes ? (curso.limite_inscricoes + " (" + (curso.limite_inscricoes - num_inscritos) + " restantes)") : null}</td>
                </tr>}
                <tr>
                  <td>Preço:</td>
                  <td>{curso.preco_disp}</td>
                </tr>
                <tr>
                  <td>Início dos registos:</td>
                  <td>{general.Renderers.dateRenderer(curso.data_abertura_registos)}</td>
                </tr>
                <tr>
                  <td>Limite de registos:</td>
                  <td>{general.Renderers.dateRenderer(curso.data_limite_registos)}</td>
                </tr>
                <tr>
                  <td>Início do curso</td>
                  <td>{general.Renderers.dateRenderer(curso.data_inicio_curso)}</td>
                </tr>
                <tr>
                  <td>Fim do curso</td>
                  <td>{general.Renderers.dateRenderer(curso.data_fim_curso)}</td>
                </tr>
              </table>
              <hr style={{margin: "10px -20px 6px"}}/>
              <Accordion
                collapses={[
                  {
                    title: "Localização",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.editLocalCurso();
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: curso.local ? <React.Fragment>
                      <p style={{textAlign: "center", fontSize: 16}}>{curso.local}</p>
                      <Map
                        googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + process.env.MAPS_KEY + "&basemap=roadmap"}
                        loadingElement={<div style={{height: `100%`}}/>}
                        lat={curso.lat}
                        lon={curso.lon}
                        containerElement={
                          <div
                            style={{
                              height: "288px",
                              borderRadius: "6px",
                              overflow: "hidden"
                            }}
                          />
                        }
                        mapElement={<div style={{height: `100%`}}/>}
                      />
                    </React.Fragment> : 'Clique no botão de editar para definir o local'
                  },
                  {
                    title: "Outros detalhes",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("outros detalhes", "Poderá especificar informações adicionais que os participantes poderão ver na página do curso:", curso.descricao_longa, async (valor) => {
                          await connection.post("curso/editar_detalhes_extra", {
                            curso: this.state.curso.id,
                            detalhes: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Outros detalhes editados", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(curso.descricao_longa || 'Clique no botão de editar para escrever as informações adicionais').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  },
                  {
                    title: "Observações",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("Observações", "Defina de seguida as observações que deverão constar no relatório do curso:", curso.observacoes, async (valor) => {
                          await connection.post("curso/editar_observacoes", {
                            curso: this.state.curso.id,
                            observacoes: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Observações editadas", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(curso.observacoes || 'Clique no botão de editar para preencher as observações').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  }
                ]}
              />
              {curso.pode_gerir && <div className={classes.cursoButtons}>
                {!curso.data_submissao && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.ativarCurso}>{curso.requer_aprov_nacional ? <>Submeter Curso</> : <>Publicar Curso</>}</Button>}
                {curso.data_submissao && !curso.data_ativacao && general.userHasPermission("curso.aprovar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.aprovarCurso}>Aprovar/Publicar Curso</Button>}
                {this.state.curso.estado.code === general.estadosAcontecimento.FINALIZADO && general.userHasPermission("curso.editar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.fecharCurso}>Fechar Curso</Button>}
                {curso.estado?.can_advance && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.avancarEstado}>Avançar estado</Button>}
                {this.state.curso.estado.code === general.estadosAcontecimento.FECHADO && general.userHasType("admin") && general.userHasPermission("curso.editar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.reverterFechoCurso}>Reverter Fecho do Curso</Button>}

                {/*<Button className={classes.button + " " + classes.warning + " " + classes.sm} size="sm" onClick={() => {
                }}>Fechar Curso</Button>
                <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => {
                  let url = "reports/relatorio_curso?curso_id=" + curso.id;
                  general.openReport(url);
                }}>Descarregar Relatório</Button>*/}
              </div>}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <NavPills
            color="primary"
            alignCenter
            tabs={(() => {
              let slides = {
                participantes: {
                  tabButton: "Participantes",
                  tabIcon: Person,
                  tabContent: (() => {
                    let cards = [
                      <this.CardCandidatos/>,
                      <this.CardParticipantes/>
                    ];
                    if (!this.state.curso.data_ativacao)
                      cards = cards.slice(0, 1);
                    if (this.state.curso.data_registos_fechados)
                      cards.reverse();
                    return cards;
                  })()
                },
                /*modulos: {
                  tabButton: "Estrutura",
                  tabIcon: ViewModule,
                  tabContent: <this.CardModulos/>
                },*/
                formacoes: {
                  tabButton: "Sessões",
                  tabIcon: List,
                  tabContent: <this.CardFormacoes/>
                },
                relatorio: {
                  tabButton: "Relatório",
                  tabIcon: Description,
                  tabContent: <this.CardRelatorio/>
                },
                anexos: {
                  tabButton: "Anexos",
                  tabIcon: Attachment,
                  tabContent: <AnexoAcontecimento id_acontecimento={this.state.curso.acontecimento} setModal={m => this.setState({modal: m})}/>
                },
              };
              if (this.state.curso.data_ativacao || this.state.curso.data_submissao)
                return [...(this.state.curso.estado.code >= general.estadosAcontecimento.FECHADO && curso.pode_gerir ? [slides.relatorio] : []), slides.participantes, slides.formacoes, slides.anexos];
              return [/*slides.modulos, */slides.participantes, slides.formacoes, slides.anexos];
            })()}
          />
        </GridItem>
      </GridContainer>
    </div>) : (<span>Loading..</span>);
  }

  ativarCurso = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    let error = null;
    try {
      await connection.get("curso/validar_informacoes", {curso: curso.id}, null, null, {disableNotif: true, returnError: true});
    } catch (e) {
      error = e.message;
    }

    window.App.openModal(<SweetAlert
      warning
      title={curso.requer_aprov_nacional ? <>Submeter Curso</> : <>Publicar Curso</>}
      onConfirm={async () => {
        await connection.post("curso/ativar", {curso: curso.id});
        window.App.hideModal();
        this.props.reloadDetalhes();
        general.success(curso.requer_aprov_nacional ? "Curso submetido com sucesso." : "Curso publicado com sucesso.");
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText={curso.requer_aprov_nacional ? "Submeter" : "Publicar"}
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      {error && <SnackbarContent
        message={error}
        color="warning"
      />}
      <p style={{marginTop: 10}}>Tem a certeza que pretende {curso.requer_aprov_nacional ? "submeter" : "publicar"} o curso em questão? Não poderá alterar a região, agrupamento e núcleo depois de o fazer e as modificações nas datas serão limitadas. As vagas não poderão ser reduzidas. Não será possível fazer alterações na estrutura do curso. {!!curso.requer_aprov_nacional && <strong>O curso ficará disponível para o público após revisão e aprovação.</strong>}</p>

      <p className={classes.courseDetails}>Informações do curso:
        <table>
          <tr>
            <td>Região*:</td>
            <td>{curso.regiao || '-'}</td>
          </tr>
          <tr>
            <td>Núcleo*:</td>
            <td>{curso.nucleo || '-'}</td>
          </tr>
          {/*<tr>
            <td>Agrupamento*:</td>
            <td>{curso.agrupamento || '-'}</td>
          </tr>*/}
          <tr>
            <td>Vagas:</td>
            <td>{curso.vagas || "Por definir"}</td>
          </tr>
          <tr>
            <td>Preço:</td>
            <td>{curso.preco_disp}</td>
          </tr>
          <tr>
            <td>Início dos registos:</td>
            <td>{general.Renderers.dateRenderer(curso.data_abertura_registos)}</td>
          </tr>
          <tr>
            <td>Limite de registos:</td>
            <td>{general.Renderers.dateRenderer(curso.data_limite_registos)}</td>
          </tr>
          <tr>
            <td>Início do curso</td>
            <td>{general.Renderers.dateRenderer(curso.data_inicio_curso)}</td>
          </tr>
          <tr>
            <td>Fim do curso</td>
            <td>{general.Renderers.dateRenderer(curso.data_fim_curso)}</td>
          </tr>
        </table>
        <small>* não poderão ser modificados após publicação</small>
      </p>
    </SweetAlert>);
  };

  aprovarCurso = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    this.setState({
      modal: <SweetAlert
        showClose
        style_options={{position: 'absolute', top: '-130px'}}
        warning
        title={"Aprovar/Publicar Curso"}
        onCancel={() => this.hideModal()}
        confirmBtnText={<>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.danger + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async () => {
            await connection.post("curso/rejeitar_submissao", {curso: curso.id});
            window.App.hideModal();
            this.hideModal();
            this.props.reloadDetalhes();
            general.success("Submissão rejeitada com sucesso.");
          }}>Rejeitar
          </button>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.primary + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async () => {
            await connection.post("curso/aprovar", {curso: curso.id});
            window.App.hideModal();
            this.hideModal();
            this.props.reloadDetalhes();
            general.success("Curso publicado com sucesso.");
          }}>Publicar
          </button>
        </>}
        confirmBtnStyle={{appearance: "none", border: "none", background: "none", padding: 0}}
      >
        <p style={{marginTop: 10}}>Tem a certeza que pretende publicar o curso em questão? O curso ficará imediatamente disponível para o público.</p>
      </SweetAlert>
    });
  }

  fecharCurso = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;
    let feedback_forcado = false;

    let Content = () => {
      const [feedbackForcado, setFeedbackForcado] = useState(!!feedback_forcado);

      return <>
        <p style={{marginTop: 10}}>Ao fechar este curso todas as qualificações pendentes nos módulos serão marcadas como "Não qualificado".</p>
        {curso.pode_forcar_feedback && <>
          <p style={{marginTop: 5}}>Caso opte por "Qualificar participantes sem feedback", os formandos que não enviaram feedback poderão ser qualificados se tiverem presença e nota sofucientes nos módulos desde curso.</p>
          <p style={{marginTop: 5}}>Será possível modificar informações e detalhes do curso até o momento em que o respetivo relatório seja validado.</p>
          <form>
            <FormControlLabel
              control={
                <Checkbox
                  checked={feedbackForcado}
                  tabIndex={-1}
                  onClick={() => {
                    feedback_forcado = !feedback_forcado;
                    setFeedbackForcado(!feedbackForcado);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Qualificar participantes sem feedback"}
            /><br/>
          </form>
        </>}
      </>
    }

    this.setState({
      modal: <SweetAlert
        warning
        title={"Fechar Curso"}
        onConfirm={async () => {
          await connection.post("curso/fechar", {curso: curso.id, feedback_forcado: feedback_forcado});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesCurso();
          general.success("Curso fechado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Fechar Curso"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>
    });
  }

  reverterFechoCurso = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Reverter Fecho do Curso"}
        onConfirm={async () => {
          await connection.post("curso/reverter_fecho", {curso: curso.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesCurso();
          general.success("Curso reaberto com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Confirmar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>Ao reverter o fecho deste curso todas as qualificações sem feedback nos módulos serão revertidas.</p>
        <p style={{marginTop: 5}}>As notas e presenças nos módulos deste curso poderão ser reavaliadas e o curso poderá ser fechado com a opção de qualificar ou não qualificar por falta de feedback.</p>
      </SweetAlert>
    });
  }

  avancarEstado = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Avançar estado"}
        onConfirm={async () => {
          await connection.post("curso/avancar_estado", {curso: curso.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesCurso();
          general.success("Estado alterado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Confirmar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 5}}>Para efeitos de demonstração, é possível avançar o estado do curso em questão. Pretende alterar o estado para <strong>{curso.estado?.proximo?.designation}</strong>?</p>
      </SweetAlert>
    });
  }

  submeterRelatorio = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Submeter relatório"}
        onConfirm={async () => {
          await connection.post("curso/relatorio/submeter", {curso_id: curso.id});
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório submetido com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Submeter"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório será submetido para aprovação e não poderá voltar a ser editado, a menos que seja rejeitado.</p>
      </SweetAlert>
    });
  }

  aprovarRelatorio = async (preliminar) => {
    const {classes} = this.props;
    const curso = this.state.curso;
    let dados = {
      curso_id: curso.id,
      ordem_servico: curso.relatorio_os || "",
      ordem_servico_data: curso.relatorio_os_data || null,
      requer_aprov_nacional: curso.requer_aprov_nacional
    };

    let url = preliminar ? "curso/relatorio/aprovar_preliminar" : "curso/relatorio/aprovar";

    this.setState({
      modal: <SweetAlert
        warning
        title={"Aprovar relatório"}
        onConfirm={async () => {
          console.log(dados)
          if (preliminar && !dados.ordem_servico.trim()) {
            general.error("Indique a ordem de serviço.");
            return;
          }
          await connection.post(url, dados);
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório aprovado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Aprovar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório será marcado como aprovado e não poderá ser modificado novamente.</p>
        {preliminar && <>
          <CustomInput
            labelText="Ordem de serviço"
            disabled
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              defaultValue: dados.ordem_servico,
              onChange: (e) => {
                dados.ordem_servico = e.target.value
              }
            }}
          />
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data da Ordem de Serviço
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolha a data"}}
              onChange={(value) => {
                dados.ordem_servico_data = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={false}
              defaultValue={dados.ordem_servico_data}
            />
          </FormControl>
        </>}
      </SweetAlert>
    });
  }

  recusarRelatorio = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Recusar relatório"}
        onConfirm={async () => {
          await connection.post("curso/relatorio/recusar", {curso_id: curso.id});
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório recusado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Recusar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório voltará ao estado "pendente de submissão" para ser corrigido pelo diretor de curso.</p>
      </SweetAlert>
    });
  }

  reabrirRelatorio = async () => {
    const {classes} = this.props;
    const curso = this.state.curso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Reabrir relatório"}
        onConfirm={async () => {
          await connection.post("curso/relatorio/reabrir", {curso_id: curso.id});
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório reaberto com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Reabrir"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório voltará ao estado "pendente de submissão" e deverá ser submetido novamente pelo diretor de curso.</p>
      </SweetAlert>
    });
  }

  newModuloModal = async (area) => {
    const {classes} = this.props;
    let modelo_modulo = null;
    let modelo_modulo_obrigatorio = 0;

    let modulos = await connection.get("modulo/listagem?area=" + parseInt(area.id));

    //Filtrar módulos para ocultar usados
    let modulos_usados = this.state.modulos.modulos.map((mod) => mod.id);
    modulos = modulos.filter((modulo) => !modulos_usados.includes(modulo.id));

    let Content = () => {
      const [modelo_modulo_state, setModeloModulo] = useState(null);
      const [modelo_modulo_obrigatorio_state, setObrigatorio] = useState(modelo_modulo_obrigatorio);

      return <form autoComplete="off" className={classes.addForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Módulo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={modelo_modulo_state}
            onChange={(event) => {
              modelo_modulo = event.target.value;
              setModeloModulo(event.target.value);
            }}
            inputProps={{
              name: "modelo_modulo",
              id: "modelo_modulo"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>{modulos.length > 0 ? "Escolha o módulo" : "Não existem mais módulos para esta área"}</MenuItem>
            {modulos.map((area) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={area.id}>{area.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={modelo_modulo_obrigatorio_state}
              tabIndex={-1}
              onClick={() => {
                modelo_modulo_obrigatorio = !modelo_modulo_obrigatorio;
                setObrigatorio(modelo_modulo_obrigatorio);
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Obrigatório"}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Módulo</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/modulo/novo", {
            modulo: modelo_modulo ? modelo_modulo : undefined,
            obrigatorio: modelo_modulo_obrigatorio,
            curso: this.state.curso.id
          });
          this.reloadModulosCurso();
          general.success("Adicionado novo módulo.", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Criar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  editModuloModal = async (modulo) => {
    const {classes} = this.props;

    let modelo_modulo_obrigatorio = modulo.obrigatorio;

    let Content = () => {
      const [modelo_modulo_obrigatorio_state, setObrigatorio] = useState(modelo_modulo_obrigatorio);

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Módulo"
          id="modelo_modulo_editar"
          disabled
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.designacao,
            name: "modelo_modulo_editar",
            disabled: true
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={modelo_modulo_obrigatorio_state}
              tabIndex={-1}
              onClick={() => {
                modelo_modulo_obrigatorio = !modelo_modulo_obrigatorio;
                setObrigatorio(modelo_modulo_obrigatorio);
              }}
              checkedIcon={<Check className={classes.checkedIcon}/>}
              icon={<Check className={classes.uncheckedIcon}/>}
              classes={{
                checked: classes.checked
              }}
            />
          }
          classes={{
            label: classes.label
          }}
          label={"Obrigatório"}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Módulo</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/modulo/editar", {
            curso: this.state.curso.id,
            modulo: modulo.id,
            obrigatorio: modelo_modulo_obrigatorio
          });
          this.reloadModulosCurso();
          general.success("Módulo editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  editLocalCurso = async () => {
    const {classes} = this.props;

    let data = {
      lat: this.state.curso.lat,
      lon: this.state.curso.lon,
      local: this.state.curso.local
    };

    let Content = () => {

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Local*"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: data.local,
            onChange: (e) => {
              data.local = e.target.value
            }
          }}
        />
        <CustomInput
          labelText="Latitude"
          formControlProps={{
            fullWidth: true
          }}
          labelProps={{
            shrink: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            step: '0.0000001',
            placeholder: '38,707778',
            defaultValue: data.lat,
            onChange: (e) => {
              data.lat = e.target.value
            }
          }}
        />
        <CustomInput
          labelText="Longitude"
          formControlProps={{
            fullWidth: true
          }}
          labelProps={{
            shrink: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            step: '0.0000001',
            placeholder: '-9,151648',
            defaultValue: data.lon,
            onChange: (e) => {
              data.lon = e.target.value
            }
          }}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Local</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/editar_local", {
            curso: this.state.curso.id,
            lat: data.lat,
            lon: data.lon,
            designacao: data.local
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Local editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <div style={{margin: "10px 0px 30px"}}>
          <SnackbarContent
            message={
              'Apenas o campo de Local é obrigatório, os outros campos serão preenchidos automaticamente após submissão. Se pretender definir o local específico indique as coordenadas.'
            }
            color="info"
          />
        </div>
        <Content/>
      </SweetAlert>)
    });
  };

  confirmDeleteModulo = (modulo) => {
    console.log(modulo);
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Módulo"
          onConfirm={() => {
            connection.post("curso/modulo/apagar", {modulo: modulo.id, curso: this.state.curso.id}, (data) => {
              if (data.success) {
                this.reloadModulosCurso();
                general.success("Módulo '" + modulo.designacao + "' apagado com sucesso.", "Sucesso!");
              } else {
                general.error("Por favor tente novamente mais tarde.", "Erro!");
              }
            })
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Está prestes a apagar o módulo '{modulo.designacao}'. Esta ação é irreversível.
        </SweetAlert>
      )
    });
  }

  CardCandidatos = () => {
    const [filter, setFilter] = useState("");
    const {classes} = this.props;
    const acontecimento = this.state.curso;
    const num_candidatos = this.state.participantes.candidatos?.length;

    let candidaturas_pagas = this.state.participantes.candidatos;
    if (candidaturas_pagas)
      candidaturas_pagas = candidaturas_pagas.filter(candidato => candidato.estado_pagamento === 'pago').length > 0;

    let info_registos = '';
    if (this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_ABERTOS)
      info_registos = " (registos a decorrer)";
    if (this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_FECHADOS)
      info_registos = " (registos fechados)";
    if (this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_FINALIZADOS)
      info_registos = " (registos finalizados)";

    let colunas = [
      {
        Header: "Nome",
        accessor: "nome",
        Cell: (row) => {
          return <span>
                  <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                    window.App.hist.push("/perfil/" + row.original.id);
                  }}> <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                  </a> {row.original.apurado && <Tooltip
            title="Apurado"
            placement="top"
            classes={{tooltip: classes.tooltip}}
          >
            <span><FontAwesomeIcon style={{color: "#16924a", height: "auto", marginLeft: "3px"}} icon={faCheckCircle}/></span>
          </Tooltip>}
            {row.original.preco > 0 && row.original.data_selecao && <Tooltip
              title="A aguardar pagamento"
              placement="top"
              classes={{tooltip: classes.tooltip}}
            >
              <span><FontAwesomeIcon style={{color: "#FFC107", height: "auto", marginLeft: "3px"}} icon={faCoins}/></span>
            </Tooltip>}</span>;
        }
      },
      {
        Header: "Data de inscrição",
        accessor: "data_registo",
        Cell: general.Renderers.dateRenderer
      },
      {
        Header: "Pontos",
        id: "cursoCandiatoPrioridade",
        accessor: (d) => d.prioridade_inscricao !== null ? d.prioridade_inscricao : ' - ',
        width: 100
      }
    ]

    if (this.state.curso.pagamento_antecipado)
      colunas.push({
        Header: "Estado de pagamento",
        accessor: "estado_pagamento"
      })

    colunas.push({
      Header: "Estado",
      accessor: "aceite_curso",
      Cell: (row) => <RegistrationState {...row.original.estado_registo}/>,
      width: 150,
      getProps: () => {
        return {
          style: {
            textAlign: "center"
          },
        };
      }
    })

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>{this.state.participantes.candidatos?.length === 1 ? 'Candidato' : 'Candidatos'} {num_candidatos > 0 ? `(${num_candidatos})` : null}{info_registos ? <><br/><small>{info_registos}</small></> : null}</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
          {acontecimento.pode_gerir && this.state.curso.estado.code >= general.estadosAcontecimento.PUBLICO && this.state.curso.estado.code < general.estadosAcontecimento.REGISTOS_FINALIZADOS && <React.Fragment>
            <Button disabled={acontecimento.limite_inscricoes && (acontecimento.inscritos >= acontecimento.limite_inscricoes)} className={classes.addStuffButton + " " + classes.button + " " + classes.primary} onClick={() => this.inscreverFormando()}>
              <Add/> Adicionar Candidato
            </Button>
            {this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_FECHADOS && <>
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger + ((this.state.curso.pagamento_antecipado && this.state.curso.pagamentos_pendentes) ? " " + classes.disabled : "")} onClick={() => {
                window.App.openModal(<SweetAlert
                  warning
                  title={"Finalizar Registos"}
                  onConfirm={async () => {
                    window.App.hideModal();
                    await connection.post("curso/participantes/finalizar_registos", {id_curso: this.state.curso.id});
                    this.props.reloadDetalhes();
                    general.success("Registos finalizados com sucesso.");
                  }}
                  onCancel={() => window.App.hideModal()}
                  confirmBtnText="Finalizar"
                  showCancel
                  cancelBtnText="Cancelar"
                  confirmBtnCssClass={
                    classes.button + " " + classes.primary + " " + classes.buttonConfirm
                  }
                  cancelBtnCssClass={
                    classes.button
                  }
                >
                  Tem a certeza que pretende finalizar os registos? Não será possível adicionar ou aprovar candidatos e os candidatos que não foram aprovados irão ser notificados de que o seu registo não foi aceite. <strong>Esta ação é irreversível</strong>.
                </SweetAlert>);
              }}>
                <Close/> Finalizar Registos
              </Button>
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.warning + ((this.state.curso.pagamento_antecipado && this.state.curso.pagamentos_pendentes) ? " " + classes.disabled : "")} onClick={() => {
                window.App.openModal(<SweetAlert
                  warning
                  title={"Validar Candidatos"}
                  onConfirm={async () => {
                    window.App.hideModal();
                    let apurados = this.state.participantes.candidatos.filter((a) => a.apurado).map((a) => a.id);
                    await connection.post("curso/participantes/aprovar_apurados", {id_curso: this.state.curso.id, apurados: apurados});
                    this.reloadParticipantesCurso();
                    general.success("Candidatos apurados aprovados com sucesso");
                  }}
                  onCancel={() => window.App.hideModal()}
                  confirmBtnText="Validar"
                  showCancel
                  cancelBtnText="Cancelar"
                  confirmBtnCssClass={
                    classes.button + " " + classes.primary + " " + classes.buttonConfirm
                  }
                  cancelBtnCssClass={
                    classes.button
                  }
                >
                  Tem a certeza que pretende validar os candidatos apurados? Os candidatos apurados serão notificados e serão emitidos os pedidos de pagamento (caso aplicável).
                </SweetAlert>);
              }}>
                <Check/> Validar apurados
              </Button>
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={async () => {
                await connection.post("curso/participantes/calcular_apurados", {id_curso: this.state.curso.id});
                this.reloadParticipantesCurso();
                general.success("Candidatos recalculados com sucesso");
              }}>
                <Refresh style={{margin: 0}}/>
              </Button>
            </>}
          </React.Fragment>}
          {acontecimento.pode_gerir && this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_FINALIZADOS && candidaturas_pagas && <React.Fragment>
            <Button className={classes.addStuffButton + " " + classes.button + " " + classes.warning + ((candidaturas_pagas) ? "" : " " + classes.disabled)} onClick={this.moverCandidatos}>
              Mover Candidatos
            </Button>
          </React.Fragment>}
          {this.state.participantes.candidatos?.length > 0 && <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
                                                                 target={'_blank'}
                                                                 href={Connection.getFullUrl("curso/participantes/listagem", {id_curso: this.state.curso.id, exportar_candidatos: true})}>
            <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
          </a>}
        </div>
      </CardHeader>
      <ReactTable
        placeholder={["Nesta área serão apresentados os candidatos ao curso.", <br/>, "Verifique que publicou o curso para que os candidatos se possam inscrever."]}
        data={general.filterTable(this.state.participantes.candidatos, filter)}
        minRows={1}
        SubComponent={(row) => <UserDetailsBox {...row.original} dataUrl={`curso/participantes/detalhes?id_curso=${this.state.curso.id}&id=${row.original.id}`} reloadData={this.reloadParticipantesCurso}/>}
        columns={colunas}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  }

  CardParticipantes = () => {
    const [filter, setFilter] = useState("");
    const [exportPopover, setExportPopover] = useState(null);
    const {classes} = this.props;
    const acontecimento = this.state.curso;
    const num_participantes = this.state.participantes.participantes?.length;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>{this.state.participantes.participantes?.length === 1 ? 'Participante' : 'Participantes'} {num_participantes > 0 ? `(${num_participantes})` : null}</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
          {this.state.participantes.participantes?.length > 0 && <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
                                                                    target={'_blank'}
                                                                    onClick={e => general.userHasType("admin") ?
                                                                      setExportPopover(e.target) :
                                                                      window.open(Connection.getFullUrl("curso/participantes/listagem", {id_curso: this.state.curso.id, exportar_participantes: true}))}>
            <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
          </a>}
          <Popover
            open={!!exportPopover}
            anchorEl={exportPopover}
            onClose={() => setExportPopover(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: -10,
              horizontal: 'center',
            }}>
            <Paper className={classes.dropdown}>
              <MenuList role="menu">
                <MenuItem onClick={() => {
                  window.open(Connection.getFullUrl("curso/participantes/listagem", {id_curso: this.state.curso.id, exportar_participantes: true}));
                  setExportPopover(null);
                }}>
                  Listagem simples
                </MenuItem>
                <MenuItem onClick={() => {
                  window.open(Connection.getFullUrl("curso/participantes/listagem", {id_curso: this.state.curso.id, exportar_participantes: true, modelo_moodle: true}));
                  setExportPopover(null);
                }}>
                  Modelo Moodle
                </MenuItem>
              </MenuList>
            </Paper>
          </Popover>
          {acontecimento.pode_gerir && general.userHasPermission("curso.inscrever_recurso") && this.state.curso.estado.code >= general.estadosAcontecimento.REGISTOS_FINALIZADOS && this.state.curso.estado.code < general.estadosAcontecimento.A_DECORRER
            && this.state.curso.vagas_livres > 0 && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} onClick={() => this.inscreverFormando(true)}>
              <Add/> Adicionar Participante
            </Button>}
        </div>
      </CardHeader>
      <ReactTable
        placeholder={"Este curso ainda não tem participantes"}
        data={general.filterTable(this.state.participantes.participantes, filter)}
        minRows={1}
        SubComponent={(row) => <UserDetailsBox {...row.original} dataUrl={`curso/participantes/detalhes?id_curso=${this.state.curso.id}&id=${row.original.id}`} reloadData={this.reloadParticipantesCurso}/>}
        columns={[
          {
            Header: "Nome",
            accessor: "nome",
            Cell: (row) => {
              return (
                <span>
                  {row.original.acoes_utilizador && row.original.acoes_utilizador.length > 0 && row.original.acoes_utilizador.find((a) => !a.optional === true) && <Tooltip
                    title={"Existem ações pendentes, expanda para ver mais"}
                    placement="top"
                  ><span><FontAwesomeIcon icon={faExclamationTriangle} color={"#fd9729"}/> </span></Tooltip>}
                  <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                    window.App.hist.push("/perfil/" + row.original.id);
                  }}>
                    <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/></a>
                </span>
              );
            }
          },
          {
            Header: "Registo aprovado",
            accessor: "data_aprovacao",
            Cell: general.Renderers.dateRenderer
          },
          {
            Header: "Estado",
            accessor: "estado_participacao",
            Cell: (row) => {
              try {
                return <EstadoParticipacaoCurso estado={{resultado: JSON.parse(row.value).resultado}}/>
              } catch (e) {
                console.log(e);
              }
            }
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  };

  CardModulos = () => {
    const {classes} = this.props;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Gerir Estrutura</h4>
        </div>
        <p>Adicione ou remova módulos disponibilizados neste curso. Apenas pode remover ou editar módulos adicionados por si.</p>
      </CardHeader>
      <CardBody>
        {this.state.modulos && <Accordion
          collapses={
            this.state.modulos.areas.map((area) => {
              let areaContent = [];
              let modulos_area = this.state.modulos.modulos.filter((modulo) => modulo.area === area.id);
              modulos_area.sort((a, b) => a.id - b.id).sort((a, b) => b.obrigatorio - a.obrigatorio);
              modulos_area.forEach((modulo) => {
                areaContent.push(<GridItem xs={12} sm={6} md={3} key={"modulo" + modulo.id}>
                  <Card color="primary" className={classes.moduloCard}>
                    <CardHeader color="primary" icon className={classes.moduleCardHeader}>
                      <h4 className={classes.innerCardTitle}>{modulo.designacao}</h4>
                      {!modulo.origem_template && <div style={{position: "absolute", top: -3, right: -16}}>
                        <CustomDropdown
                          hoverColor="info"
                          buttonText={<MoreVert/>}
                          caret={false}
                          buttonProps={{
                            justIcon: true,
                            style: {marginBottom: "0"},
                            simple: true,
                            round: true
                          }}
                          dropdownList={[
                            {
                              label: "Editar",
                              onClick: () => this.editModuloModal(modulo)
                            },
                            {
                              label: "Apagar",
                              onClick: () => this.confirmDeleteModulo(modulo)
                            }
                          ]}
                        />
                      </div>}
                    </CardHeader>
                    <CardBody className={classes.moduloCardBody}>
                      <table>
                        <tr>
                          <td>Frequência:</td>
                          <td><span>{modulo.obrigatorio ? "Obrigatório" : "Opcional"}</span></td>
                        </tr>
                      </table>
                    </CardBody>
                  </Card>
                </GridItem>);
              });

              areaContent.push(<GridItem xs={12} sm={6} md={3} xl={2} key={area.id}>
                <Button
                  justIcon
                  round
                  simple
                  onClick={() => {
                    this.newModuloModal(area);
                  }}
                  color="primary"
                  className={classes.addModuloButton}
                >
                  <Add/>
                </Button>
              </GridItem>);

              let restantes = Math.max(0, modulos_area.filter((mod) => !mod.obrigatorio).length);

              return {
                area_id: area.id,
                title: "Área: " + area.designacao,
                secondaryTitle: <span>{restantes ? <span style={{color: "#ff8123"}}> (faltam {restantes})</span> : ""}</span>,
                content: <React.Fragment>
                  <GridContainer className={classes.areaContentGrid}>
                    {areaContent}
                  </GridContainer>
                </React.Fragment>
              }
            })}
        />}
      </CardBody>
    </Card>
  }

  CardFormacoes = () => {
    const {classes} = this.props;
    const [formacoes, setFormacoes] = useState(null);
    const [sessoes, setSessoes] = useState(null);

    useEffect(() => {
      connection.get("curso/formacao/listagem", {curso: this.state.curso.id}).then(formacoes => setFormacoes(formacoes.map((f, idx) => ({...f, index: idx}))));
      connection.get("curso/sessao/listagem", {curso: this.state.curso.id}).then(setSessoes);
    }, []);

    if (!sessoes || !formacoes)
      return null;

    const editarSessao = async (sessao) => {
      const {classes} = this.props;

      let dados = {
        data_inicio: sessao.data_inicio,
        data_fim: sessao.data_fim,
        designacao: sessao.designacao
      };

      let Content = () => {
        return <form autoComplete="off" className={classes.addForm}>
          <p>As datas dos módulos serão editadas juntamente com as datas da sessão</p>
          <CustomInput
            labelText="Designação"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              defaultValue: dados.designacao,
              onChange: (e) => {
                dados.designacao = e.target.value
              }
            }}
          />
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data de início
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolha a data"}}
              onChange={(value) => {
                dados.data_inicio = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={"H:mm"}
              defaultValue={dados.data_inicio}
            />
          </FormControl>
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data de fim
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolha a data"}}
              onChange={(value) => {
                dados.data_fim = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={"H:mm"}
              defaultValue={dados.data_fim}
            />
          </FormControl>
        </form>
      };

      this.setState({
        modal: (<SweetAlert
          title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
            <span className={classes.modalCardTitle}>Editar Sessão</span>
          </div>)}
          onConfirm={async () => {
            await connection.post("curso/sessao/editar", {
              curso: this.state.curso.id,
              sessao: sessao.id,
              designacao: dados.designacao,
              data_inicio: dados.data_inicio,
              data_fim: dados.data_fim
            });
            this.hideModal();
            general.success("Sessão editada", "Sucesso");
            connection.get("curso/sessao/listagem", {curso: this.state.curso.id}).then(setSessoes);
          }}
          onCancel={() => this.hideModal()}
          cancelBtnText="Cancelar"
          showCancel
          confirmBtnText="Guardar"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <Content/>
        </SweetAlert>)
      });
    };

    const criarSessao = async () => {
      await connection.post("curso/sessao/criar", {
        curso: this.state.curso.id,
      });

      general.success("Sessão criada", "Sucesso");

      connection.get("curso/sessao/listagem", {curso: this.state.curso.id}).then(setSessoes);
    }

    const confirmAlterarFormacao = async (formacao, reverter) => {
      // Alterar data de início e término da formação para ser coerente com a data de início e término da sessão
      let inicio_sessao, fim_sessao;

      if (formacao.sessao) {
        let formacao_alterada = await connection.post("acontecimento/formacao/alterar_dados", {formacao: formacao.id, sessao: formacao.sessao, curso: this.state.curso.id});

        // Data de início e fim da sessão
        inicio_sessao = moment(formacao_alterada.inicio_sessao).startOf('day').toDate();
        fim_sessao = moment(formacao_alterada.fim_sessao).endOf('day').toDate();

        // Data de início e fim da formação
        formacao.data_inicio = formacao_alterada.data_inicio_formacao;
        formacao.data_fim = formacao_alterada.data_fim_formacao;
      }

      this.setState({
        modal: (
          <SweetAlert
            warning
            title="Confirmar alteração"
            onConfirm={() => {
              connection.post("curso/formacao/editar_sessao", {formacao: formacao.id, formacao_data_inicio: formacao.data_inicio, formacao_data_fim: formacao.data_fim, sessao: formacao.sessao, curso: this.state.curso.id}, (data) => {
                if (data.success) {
                  general.success("Sessão do módulo alterada com sucesso.");
                } else {
                  general.error(data.message, "Ocorreu um erro");
                  reverter && reverter();
                }
                this.hideModal();
              })
            }}
            onCancel={() => {
              this.hideModal();
              reverter && reverter();
            }}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            cancelBtnCssClass={
              this.props.classes.button
            }
            confirmBtnText="Confirmar"
            cancelBtnText="Cancelar"
            showCancel
          >
            <FormControl fullWidth>
              <InputLabel shrink={true} className={classes.selectLabel}>
                Início do módulo
              </InputLabel>
              <Datetime
                inputProps={{placeholder: "Escolha a data"}}
                onChange={(value) => {
                  formacao.data_inicio = value;
                }}
                dateFormat={"DD/MM/YYYY"}
                timeFormat={"H:mm"}
                defaultValue={formacao.data_inicio}
                valid={(current) => {
                  return current >= inicio_sessao && current <= fim_sessao
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel shrink={true} className={classes.selectLabel}>
                Fim do módulo
              </InputLabel>
              <Datetime
                inputProps={{placeholder: "Escolha a data"}}
                onChange={(value) => {
                  formacao.data_fim = value;
                }}
                dateFormat={"DD/MM/YYYY"}
                timeFormat={"H:mm"}
                defaultValue={formacao.data_fim}
                valid={(current) => {
                  return current >= inicio_sessao && current <= fim_sessao
                }}/>
            </FormControl>
            Atenção! Esta alteração irá modificar as datas em que o módulo irá ocorrer.
          </SweetAlert>
        )
      });
    }

    const confirmApagarSessao = (sessao, confirm) => {
      const go = () => {
        connection.post("curso/sessao/apagar", {sessao: sessao, curso: this.state.curso.id}, (data) => {
          if (data.success) {
            general.success("Sessão apagada com sucesso.");
          } else {
            general.error(data.message, "Ocorreu um erro");
          }
          this.hideModal();
          connection.get("curso/sessao/listagem", {curso: this.state.curso.id}).then(setSessoes);
          connection.get("curso/formacao/listagem", {curso: this.state.curso.id}).then(formacoes => setFormacoes(formacoes.map((f, idx) => ({...f, index: idx}))));
        })
      }

      if (!confirm)
        return go();

      this.setState({
        modal: (
          <SweetAlert
            warning
            title="Apagar sessão?"
            onConfirm={() => {
              go();
            }}
            onCancel={() => {
              this.hideModal();
            }}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            cancelBtnCssClass={
              this.props.classes.button
            }
            confirmBtnText="Confirmar"
            cancelBtnText="Cancelar"
            showCancel
          >
            Os módulos da sessão deixarão de estar agrupados, mas irão manter as propriedades atuais.
          </SweetAlert>
        )
      });
    }

    const onDragEnd = ({source, destination, draggableId, ...rest}) => {
      if (!this.state.curso.pode_gerir)
        return;

      const sourceDrop = JSON.parse(source.droppableId.replace("sessao_", ""));
      const destinationDrop = JSON.parse(destination.droppableId.replace("sessao_", ""));

      let list = formacoes.filter(f => f.sessao === sourceDrop);
      let formacao = list[source.index];

      let changed = false;
      if (formacao.sessao !== destinationDrop) {
        formacao.sessao = destinationDrop;
        changed = true;
      }

      if (sourceDrop !== destinationDrop)
        list = formacoes.filter(f => f.sessao === destinationDrop);

      let originalSourceIdx = formacoes.findIndex(f => f === formacao);
      let originalDestinationIdx = formacoes.findIndex(f => f === list[destination.index]);
      setFormacoes(reorder(formacoes, originalSourceIdx, originalDestinationIdx));

      if (changed) {
        confirmAlterarFormacao(formacao, () => {
          connection.get("curso/formacao/listagem", {curso: this.state.curso.id}).then(formacoes => setFormacoes(formacoes.map((f, idx) => ({...f, index: idx}))));
        });
      }
    }

    let formacoes_sem_sessao = formacoes.filter(f => !f.sessao);

    let adicionar = this.state.curso.pode_gerir && <div style={{display: "flex", justifyContent: "center"}}>
      <div>
        <Button
          justIcon
          round
          simple
          style={{backgroundColor: "white", marginBottom: 10, marginTop: 25}}
          onClick={() => {
            criarSessao();
          }}
          color="primary"
          className={classes.addModuloButton}
        >
          <Add/>
        </Button>
        <p>Adicionar sessão</p>
      </div>
    </div>;

    return <DragDropContext onDragEnd={onDragEnd}>
      <div style={{overflow: "hidden"}}>
        <Masonry
          breakpointCols={{
            default: 2,
            600: 1
          }}
          className="cne-masonry-grid"
          columnClassName="cne-masonry-grid_column">
          {formacoes_sem_sessao.length > 0 && <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Sem sessão</h4>
              </div>
            </CardHeader>
            <Droppable droppableId={"sessao_null"}>
              {({innerRef, placeholder}, {isDraggingOver}) => (<>
                <div ref={innerRef}>
                  {formacoes_sem_sessao.length > 0 && <CardBody>
                    {formacoes_sem_sessao.filter(f => !f.sessao).map((f, idx) => <CardFormacao {...f} index={idx}/>)}
                  </CardBody>}
                  {formacoes_sem_sessao.length === 0 && <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
                    <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Arraste um módulo para remover a sessão</h5>
                  </CardBody>}
                </div>
                {placeholder}
              </>)}
            </Droppable>
          </Card>}
          {sessoes.map(s => {
              let formacoes_sessao = formacoes.filter(f => f.sessao === s.id);
              return <Card>
                <CardHeader color="primary">
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <h4 style={{flex: 1}}>{s.designacao}</h4>
                    {this.state.curso.pode_gerir && <>
                      <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={() => editarSessao(s)}>
                        <Create/> Editar
                      </Button>
                      <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={() => confirmApagarSessao(s.id, formacoes_sessao.length > 0)}>
                        <Delete/> Apagar
                      </Button>
                    </>}
                  </div>
                  {s.data_inicio && s.data_fim && <p>De {general.Renderers.dateRenderer(s.data_inicio, {hide_timezone: true})} até {general.Renderers.dateRenderer(s.data_fim, {hide_timezone: true})}</p>}
                </CardHeader>
                <Droppable droppableId={"sessao_" + s.id}>
                  {({innerRef, placeholder}, {isDraggingOver}) => (<>
                    <div ref={innerRef}>
                      {formacoes_sessao.length > 0 && <CardBody>
                        {formacoes_sessao.map((f, idx) => <CardFormacao {...f} index={idx} simples/>)}
                      </CardBody>}
                      {formacoes_sessao.length === 0 && <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
                        <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Arraste um módulo para esta sessão</h5>
                      </CardBody>}
                    </div>
                    {placeholder}
                  </>)}
                </Droppable>
              </Card>
            }
          )}
          {sessoes.length <= 1 && adicionar}
        </Masonry>
        {sessoes.length > 1 && adicionar}
      </div>
    </DragDropContext>
  };

  CardRelatorio = () => {
    const {classes} = this.props;
    const [dadosRelatorio, setDadosRelatorio] = useState(null);
    const [relatorioHTML, setRelatorioHTML] = useState(null);

    const obterDados = async () => {
      setDadosRelatorio(await connection.get("curso/relatorio/dados", {curso_id: this.state.curso.id}));
      setRelatorioHTML(await connection.get("curso/relatorio/obter_html", {curso_id: this.state.curso.id}, null, null, {disableNotif: true}));
    }

    useEffect(() => {
      obterDados();
    }, []);

    if (!dadosRelatorio)
      return null;

    const curso = this.state.curso;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Relatório {curso.relatorio_os && <small>Aceite, na {curso.requer_aprov_nacional ? "OSN" : "OSR"} {curso.relatorio_os} de {moment(curso.relatorio_os_data).format("DD/MM/YYYY")}</small>}</h4>
          {dadosRelatorio.dados_completos && <>
            {!curso.data_relatorio_submetido && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={() => {
              this.setState({
                modal: (<SweetAlert
                  title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
                    <span className={classes.modalCardTitle}>Editar Relatório</span>
                  </div>)}
                  style={{
                    width: 750, padding: 20
                  }}
                  onCancel={() => this.hideModal()}
                  cancelBtnText="Cancelar"
                  showCancel={false}
                  showConfirm={false}
                  showClose
                >
                  <EditarRelatorio dadosRelatorio={dadosRelatorio} classes={classes} idCurso={this.state.curso.id} onSubmit={() => {
                    this.hideModal();
                    obterDados();
                  }}/>
                </SweetAlert>)
              })
            }}>
              <Create/> Editar
            </Button>}
            <Button className={classes.addStuffButton + " " + classes.button + " " + classes.warning} onClick={() => {
              window.open(connection.getBase() + "curso/relatorio/obter?curso_id=" + this.state.curso.id, "_blank");
            }}>
              <CloudDownload/> Descarregar
            </Button>
            {curso.estado.code === general.estadosAcontecimento.FECHADO && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.success} onClick={this.submeterRelatorio}>
              <Send/> Submeter
            </Button>}
            {curso.estado.code === general.estadosAcontecimento.RELATORIO_SUBMETIDO && <>
              {curso.pode_aprovar_relatorio_preliminar && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.success} onClick={() => this.aprovarRelatorio(true)}>
                <Check/> Aprovar Preliminar
              </Button>}
              {curso.pode_aprovar_relatorio && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.success} onClick={() => this.aprovarRelatorio(false)}>
                <Check/> Aprovar Final
              </Button>}
              {(curso.pode_recusar_relatorio_preliminar || curso.pode_recusar_relatorio) && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={this.recusarRelatorio}>
                <Close/> Recusar
              </Button>}
            </>}
            {curso.pode_reabrir_relatorio && curso.estado.code === general.estadosAcontecimento.RELATORIO_ACEITE && <>
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={this.reabrirRelatorio}>
                <Close/> Reabrir
              </Button>
            </>}
          </>}
        </div>
      </CardHeader>
      <CardBody style={{padding: dadosRelatorio.dados_completos ? "35px" : undefined}}>
        {dadosRelatorio.dados_completos ? (relatorioHTML && Parser(relatorioHTML, {
          replace: domNode => {
            if (domNode.name === 'body')
              domNode.name = "div";
          }
        })) : <>
          <h4>Complete o seguinte formulário para emitir o relatório do curso:</h4>
          <EditarRelatorio dadosRelatorio={dadosRelatorio} classes={classes} idCurso={this.state.curso.id} onSubmit={() => {
            obterDados();
          }}/>
        </>}
      </CardBody>
    </Card>
  };

  adicionarFormacao = async (modulo, callback) => {
    const {classes} = this.props;

    let nova_formacao = {
      curso: this.state.curso.id,
      modulo: modulo.id
    };

    let Content = () => {
      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Módulo"
          disabled
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.designacao,
            disabled: true
          }}
        />
        <UserSearch
          labelText="NIN do Formador"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
          }}
          onFoundUser={(user) => {
            nova_formacao.formador = user.NIN
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Criar novo módulo</span>
      </div>)}
      onConfirm={() => {
        connection.post("curso/formacao/nova", nova_formacao, () => {
          window.App.hideModal();
          callback && callback();
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Criar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }
}

export default withStyles(cursosStyle)(PaginaCurso);
